import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

// These 2 queries are identical to
// ArchivedPageBannerV2ArchivedPageBannerContainerQuery and ArchivedPageBannerV2ArchivedPageBannerQuery
// in ./ArchivedPageBannerV2.tsx
// They are inlined in ArchivedPageBannerV2.tsx because of Relay
import { ArchivedPageBannerContainerQuery } from './ArchivedPageBannerContainerQuery.graphql';
import { ArchivedPageBannerQuery } from './ArchivedPageBannerQuery.graphql';
import { CONTENT_STATUS_ARCHIVED } from './archivingConstants';

import type {
	ArchivedPageBannerV2ArchivedPageBannerQuery as ArchivedPageBannerV2ArchivedPageBannerQuery$data,
	ArchivedPageBannerV2ArchivedPageBannerQueryVariables as ArchivedPageBannerV2ArchivedPageBannerQuery$variables,
} from './__types__/ArchivedPageBannerV2ArchivedPageBannerQuery';
import type {
	ArchivedPageBannerV2ArchivedPageBannerContainerQuery as ArchivedPageBannerV2ArchivedPageBannerContainerQuery$data,
	ArchivedPageBannerV2ArchivedPageBannerContainerQueryVariables as ArchivedPageBannerV2ArchivedPageBannerContainerQuery$variables,
} from './__types__/ArchivedPageBannerV2ArchivedPageBannerContainerQuery';

export function preloadArchivedPageBannerV2Queries(contentId: string) {
	if (!contentId) {
		return Promise.resolve();
	}

	return query<
		ArchivedPageBannerV2ArchivedPageBannerContainerQuery$data,
		ArchivedPageBannerV2ArchivedPageBannerContainerQuery$variables
	>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: ArchivedPageBannerContainerQuery,
		variables: { contentId },
	}).then(({ data }): Promise<any> | void => {
		const contentStatus = data?.content?.nodes?.[0]?.status;
		const isContentArchived = contentStatus === CONTENT_STATUS_ARCHIVED;

		if (isContentArchived) {
			return query<
				ArchivedPageBannerV2ArchivedPageBannerQuery$data,
				ArchivedPageBannerV2ArchivedPageBannerQuery$variables
			>({
				/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
				query: ArchivedPageBannerQuery,
				variables: { contentId },
			});
		}
		return Promise.resolve();
	});
}
